import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InstructionStep } from '../../../models/instructionStep.model';
import { AppStateService } from '../../../services/shared/app-state/app-state.service';

@Component({
  selector: 'app-instructions-modal',
  templateUrl: './instructions-modal.component.html',
  styleUrl: './instructions-modal.component.css'
})
export class InstructionsModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<InstructionsModalComponent>,
    private appState: AppStateService,
    @Inject(MAT_DIALOG_DATA) public data: {manager?:string, pageTitle:string, instructionSteps:InstructionStep[]}
  )
  {}

  currentStep = 0;
  steps: InstructionStep[] = [];
  isMobile = window.innerWidth <= 1023;
  isEmbed: boolean = false;

  ngOnInit()
  {
    this.isEmbed = this.appState.getIsEmbed();
    this.buildSteps();
  }

  buildSteps()
  {
    if(this.data.instructionSteps && this.data.instructionSteps.length > 0)
    {
      this.steps = this.data.instructionSteps.sort((a, b) => a.step - b.step);
      this.steps.forEach(step => {

        var src = step.src.trim();
        if(!src.toLowerCase().startsWith('http'))
        {
          step.src = `../../../../assets/images/${step.src}`;
        }

        if(step.description.includes('[icon]'))
        {
          step.description = step.description.replace("[icon]", "##ICON##");
        }
      });
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  nextStep(): void {
    //Send request for all fields to do evaluate
    if (this.currentStep < this.steps.length + 1) {
      this.currentStep++;
    }
  }

  previousStep(): void {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    this.isMobile = window.innerWidth <= 1023;
  }
}
